import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ShopOrderBatchJobQueueView } from "src/components/views/erp/production/shopOrderBatch/shopOrderBatchJobQueue/ShopOrderBatchJobQueueView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/production/shopOrderBatchJobQueue")({
	staticData: { title: i18n.t("shop_order_batch_job_queue"), legacyViewKey: "shopOrderBatchJobQueueView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ShopOrderBatchJobQueueView />;
}
